export interface OauthAuthorizeParams {
  clientId: string | null;
  scope: string;
  redirectUri: string | null;
  state: string;
  codeChallenge: string;
  codeChallengeMethod: string;
}

export function parseOauthAuthorizeParams(search: string): OauthAuthorizeParams {
  const searchParams = new URLSearchParams(search);

  return {
    clientId: searchParams.get('client_id'),
    scope: searchParams.get('scope') || '',
    redirectUri: searchParams.get('redirect_uri'),
    state: searchParams.get('state') || '',
    codeChallenge: searchParams.get('code_challenge') || '',
    codeChallengeMethod: searchParams.get('code_challenge_method') || '',
  };
}

export function buildAuthorizationCodeRequest(params: {
  integrationId: string;
  spaceId: string;
  blockIdsForBot: string[];
  redirectUri?: string;
  scope?: string;
  state?: string;
  codeChallenge?: string;
  codeChallengeMethod?: string;
}) {
  return {
    integrationId: params.integrationId,
    spaceId: params.spaceId,
    blockIdsForBot: params.blockIdsForBot,
    redirectUri: params.redirectUri,
    scope: params.scope,
    state: params.state,
    ...(params.codeChallenge
      ? {
          codeChallenge: params.codeChallenge,
        }
      : {}),
    ...(params.codeChallengeMethod
      ? {
          codeChallengeMethod: params.codeChallengeMethod,
        }
      : {}),
  };
}
